import routes from "@routes/routes";
import axios from "@axios/axiosInstance";
import Cookies from "js-cookie";

export const loginHelper = async () => {
  try {
    if (!localStorage.getItem("rememberMe")) {
      throw new Error("Log user out");
    }
    const res = await axios.post(
      "/users/jwt_tokens",
      {},
      {
        headers: {
          "Access-Control-Allow-Credentials": true,
        },
        withCredentials: true,
      }
    );
    if (res) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + res.headers["access-token"];
      const options: Cookies.CookieAttributes = {};
      if (localStorage.getItem("rememberMe")) {
        options.expires = 14 * 24 * 60 * 60;
      }
      Cookies.set("aT", `${res.headers["access-token"]}`, options);
      window.location.reload();
    }
  } catch {
    Cookies.remove("aT");
    Cookies.remove("jwt_refresh_token");
    localStorage.removeItem("aT");
    localStorage.removeItem("count");
    localStorage.setItem("rememberMe", "false");
    window.location.href =
      import.meta.env.VITE_REACT_LOCAL_HOST + routes.default;
  }
};

export const getToken = () => {
  return "Bearer " + Cookies.get("aT");
};
